var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className1},[_c('img',{class:_vm.className2,attrs:{"src":_vm.Logo.FilePath}})])}
var staticRenderFns = []

export { render, staticRenderFns }